<template>
  <a :href="'/exam/' + exam.id" class="card--img hover:bg-gray-100 group">
    <div class="p-4 md:p-6">

      <div class="exam-item__badges">
        <span v-if="exam.category" class="badge badge-success">{{ exam.category.name }}</span>
        <span v-if="isSomeInProgress" class="badge badge-warning">{{ __('test.in_progress') }}</span>

      </div>

      <h2 class="text-lg md:text-xl text-secondary-500 font-bold my-2">
        {{ exam.name }}
      </h2>

      <p v-if="exam.questions_count" class="text-sm md:text-base mb-2">Anzahl der Fragen: {{ exam.questions_count }}</p>
      <p v-if="exam.desc" class="text-sm md:text-base mb-2">{{ exam.desc }}</p>

      <div class="btn-primary group-hover:bg-secondary-500 block mt-2">{{ btnText }}</div>
    </div>
  </a>
</template>

<script>
/**
 * Shows basic informations of an Exam in a card
 *
 * @author Darius Mozgiel | mozgiel.de
 */
export default {
  name: 'ExamItem',

  props: {
    /**
     * The Exam model
     */
    exam: {
      type: Object,
    },
  },

  data() {
    return {
      isCurrentTest: false,
    }
  },

  computed: {
    isSomeInProgress() {
      if( ! this.exam.tests.length > 0 ) return false

      let inProgress = false
      this.exam.tests.map( test => {
        if( test.status === 1 ) {
          inProgress = true
        }
      })
      return inProgress
    },

    currentTestInfo() {
      let currentTests = 0
      let finishedTest = 0
      let info = ''
      this.exam.tests.map( test => {
        if( test.status < 2 ) {
          currentTests++
        } else {
          finishedTest++
        }
      })

      if( currentTests > 0 ) {
        this.isCurrentTest = true
        info = 'Du bearbeitest diese Prüfung momentan.'
      }

      if( finishedTest > 0 ) {
        info = `Du hast diese Prüfung bereits ${finishedTest} abgeschlossen.`
      }

      return info
    },

    btnText() {
      return ( this.isCurrentTest ) ? 'Prüfung fortsetzen' : 'Prüfung starten'
    }
  },
}
</script>

<style scoped>

</style>
